<template>
  <div>
    <el-dialog title="新建活动"
               :visible.sync="dialogFormVisible"
               @close="emitClose"
               :close-on-click-modal="false"
               width="620px">
      <el-form :model="dataForm"
               label-position="right"
               ref="formRules"
               :rules="rules"
               label-width="100px"
               size="small">
        <el-form-item label="活动名称："
                      prop="name">
          <el-input v-model="dataForm.name"
                    placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="关联链接："
                      prop="ref_redirect_url">
          <el-input v-model="dataForm.ref_redirect_url"
                    placeholder="请输入关联链接"></el-input>
        </el-form-item>
        <el-form-item label="关联图片："
                      prop="ref_img_urls">
          <el-upload :action="imgUploadUrl"
                     list-type="picture-card"
                     :on-remove="handleRemove"
                     :on-success="handleSuccess"
                     :file-list="fileList"
                     :limit="9">
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="warn">注：最多可上传9张图片，前台将只随机展示其中一张！</div>
        </el-form-item>
        <el-form-item label="关联内容："
                      prop="ref_content_text">
          <el-input type="textarea"
                    v-model="dataForm.ref_content_text"
                    placeholder="请输入关联内容"></el-input>
        </el-form-item>
        <el-form-item label="是否上线："
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>

      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="emitClose(false)">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { promotionCreate } from '@/api/promotion'

export default {
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {},
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      imgUploadUrl: imgUploadUrl(),
      fileList: [],
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url,
      })
    },
    emitClose() {
      this.dataForm = {}
      this.fileList = []
      this.$emit('close')
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            name: this.dataForm.name,
            ref_img_urls: this.fileList
              .map((v) => {
                return v.url
              })
              .join(','),
            ref_content_text: this.dataForm.ref_content_text,
            ref_redirect_url: this.dataForm.ref_redirect_url,
            status: this.dataForm.status ? 1 : 0,
          }
          console.log('this.query', query)
          promotionCreate(query).then((res) => {
            this.$message.success(`添加成功`)
            this.$emit('submit')
            this.emitClose()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.warn {
  font-weight: 400;
  font-size: 12px;
  color: #c0c4cc;
}
</style>